import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'color',
    standalone: false
})
export class ColorPipe implements PipeTransform {
  public transform(value: any): string {
    function addZeros(num: number): string {
      let zeros = '';
      for (let i = 0; i < num; i++) {
        zeros += '0';
      }
      return zeros;
    }
    return '#' + addZeros(6 - value.toString(16).length) + value.toString(16);
  }
}
